import React, { useState } from "react";
import { 
  FaHome, FaUsers, FaHandHoldingHeart, 
  FaClipboardList, FaUser, FaBars, FaTimes 
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import Ologso from "../assets/OGEP LOGO.png";
import classes from "./NewHeader.module.css"; // CSS Module import
import OLogo from "../assets/whitedash.svg";// Logo image import
import HomeIcon from "../assetss-header/home.svg";// Logo image import
import UserIcon from "../assetss-header/user.svg";// Logo image import
import ApplyIcon from "../assetss-header/assist.svg";// Logo image import
import StatusIcon from "../assetss-header/status.svg";// Logo image import
import ProfileIcon from "../assetss-header/profile.svg";// Logo image import
import NotifyIcon from "../assetss-header/notify.svg";// Logo image import

const NewHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
const location = useLocation();
  const menuItems = [
    { name: "Home", icon: HomeIcon, link: "/dashboard" },
    { name: "Household Members", icon: UserIcon, link: "/household" },
    { name: "Apply for Assistance", icon: ApplyIcon, link: "/assistance" },
    { name: "Application Status", icon: StatusIcon, link: "/application_status" },
    { name: "My Profile", icon: ProfileIcon, link: "/profile" },
    // { name: "Notifications", icon: NotifyIcon, link: "/notifications" },
  ];

  return (
    <>
      {/* Fixed header */}
      <header className={classes.headerNav}>
        <div className={classes.headerContainer}>
         <img src={OLogo} alt="" className={classes.logo} />

          {/* Desktop Menu */}
          <nav className={classes.desktopMenu}>
            {menuItems.map((item) => (
              <a
  key={item.name}
  href={item.link}
  className={`${classes.menuItem} ${
    location.pathname === item.link ? classes.activeMenuItem : ""
  }`}
>
  <img src={item.icon} alt={item.name} className={classes.menuIcon} />
  <span className={classes.menuText}>{item.name}</span>
</a>
            ))}
            <img src={NotifyIcon} alt='Notification' className={classes.notificationIcon} />
          </nav>

          {/* Hamburger button for mobile */}
          <button className={classes.hamburger} onClick={() => setIsOpen(true)}>
            <FaBars color="white"/>
          </button>
        </div>
      </header>

      {/* Mobile Side Menu */}
      <div className={`${classes.mobileMenu} ${isOpen ? classes.open : ""}`}>
        <div className={classes.mobileMenuHeader}>
           <img src={OLogo} alt="" className={classes.logo} />
          <button className={classes.closeBtn} onClick={() => setIsOpen(false)}>
            <FaTimes color="white"/>
          </button>
        </div>
        <nav className={classes.mobileMenuItems}>
  {menuItems.map((item) => (
    <a
      key={item.name}
      href={item.link}
      className={`${classes.mobileMenuItem} ${
        location.pathname === item.link ? classes.activeMenuItem : ""
      }`}
      onClick={() => setIsOpen(false)}
    >
      <img src={item.icon} alt={item.name} className={classes.mobileMenuIcon} />
      <span className={classes.mobileMenuText}>{item.name}</span>
    </a>
  ))}
   <img src={NotifyIcon} alt='Notification' className={classes.notificationIcon} />
</nav>
      </div>

      {/* Spacing so content doesn't hide under fixed header */}
      <div className={classes.headerSpacer}></div>
    </>
  );
};

export default NewHeader;